import { render, staticRenderFns } from "./studioDashboardDaycareStatistic.vue?vue&type=template&id=512029aa&scoped=true"
import script from "./studioDashboardDaycareStatistic.vue?vue&type=script&lang=js"
export * from "./studioDashboardDaycareStatistic.vue?vue&type=script&lang=js"
import style0 from "./studioDashboardDaycareStatistic.vue?vue&type=style&index=0&id=512029aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512029aa",
  null
  
)

export default component.exports